import magnifiAPIInstance from "./apiInstance";

export const bumperAPIs = {
  getBumpers: ({ payload }) => magnifiAPIInstance.post(`/sony_get_advertisement`, payload),
  deleteBumper: ({ payload }) => magnifiAPIInstance.post(`/delete_slate_video`, payload),
  getBumperDetails: ({ id }) => magnifiAPIInstance.get(`/api/v3/get_slate_video_details/${id}`),
};
